import { observer } from 'mobx-react';
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { accountStore } from 'store/accountStore';
import { getDefaultRoute } from 'utils/getDefaultRoute';

export interface PermissionGuardProps {
  menu: string;
  children: React.ReactNode;
}

/**
 * 제한 계정(prefix 전용 권한만 보유)에 한해 라우트 진입 시 메뉴 키 매칭을 강제.
 * - vendor-only: 전부 `vendor-*` 권한
 * - vietnam-only: 전부 `vietnam-*` 권한 (accountStore.isVietnamOnly)
 * 일반 어드민은 기존 동작 그대로 (BE 권한 검증에 의존).
 */
export const PermissionGuard: React.FC<PermissionGuardProps> = observer(({ menu, children }) => {
  const location = useLocation();

  if (!accountStore.isInit()) {
    return null;
  }

  // Super admin: 권한 무관 모든 접근 허용.
  if (accountStore.isSuperAdmin()) {
    return <>{children}</>;
  }

  const permissionList = accountStore
    .getPermissions()
    .map(p => p.split(':')[0]);
  const isVendorOnly =
    permissionList.length > 0 && permissionList.every(key => key.startsWith('vendor-'));

  if (!isVendorOnly && !accountStore.isVietnamOnly()) {
    return <>{children}</>;
  }

  const menus = accountStore.getMenus();
  if (menus.includes(menu)) {
    return <>{children}</>;
  }

  const fallback = getDefaultRoute();
  if (fallback === location.pathname) {
    return null;
  }
  return <Navigate to={fallback} replace />;
});
